import { combineReducers } from 'redux'
import prompt from './snackbar/reducer'
import loader from './loader/reducer'
import authReducer from './authentication/reducer'
import ContactDetailsReducer from 'redux/contactDetails/reducer'
import MenuToggleReducer from 'redux/menuDrawer/reducer'

const rootReducer = combineReducers({
  snackbar: prompt,
  loader: loader,
  authReducer: authReducer,
  contactDetailsReducer: ContactDetailsReducer,
  MenuToggleReducer: MenuToggleReducer,
})

export default rootReducer
